<template>
  <div class="d-flex align-center py-2 referral-user-row">
    <div class="user-name text-body-1 mr-3">
      {{ user.name || `user#${user.id}` }}
    </div>

    <div class="d-flex flex-grow-1 referral-user-cells">
      <v-card
        v-for="opt in referralOptions"
        :key="opt.id"
        :outlined="selectedReferralId !== opt.id"
        :color="selectedReferralId === opt.id ? 'primary' : ''"
        :dark="selectedReferralId === opt.id"
        class="referral-card flex-grow-1"
        @click="handleToggle(opt.id)"
      >
        <v-card-text
          :class="[
            'pa-3 text-center font-weight-medium',
            selectedReferralId === opt.id ? 'white--text' : '',
          ]"
        >
          {{ opt.name }}
        </v-card-text>
      </v-card>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReferralUserRow',
  props: {
    user: { type: Object, required: true },
    referralOptions: { type: Array, required: true },
    selectedReferralId: { type: [Number, String], default: null },
  },
  emits: ['change'],
  setup(props, { emit }) {
    // 同じラベルを再タップで解除（指名と同じトグル動作）
    const handleToggle = referralId => {
      const next = props.selectedReferralId === referralId ? null : referralId
      emit('change', { referralId: next })
    }

    return { handleToggle }
  },
}
</script>

<style scoped>
.referral-user-row {
  border-bottom: 1px solid rgba(127, 127, 127, 0.12);
}
.referral-user-cells {
  display: flex;
  gap: 8px;
}
.referral-card {
  cursor: pointer;
  min-height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.user-name {
  min-width: 120px;
  flex-shrink: 0;
}
</style>
